"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPACING = exports.SMALL_BREAKPOINT_VALUE = exports.SMALL_BREAKPOINT_SETTINGS = exports.SMALL_BREAKPOINT_PER_VIEW = exports.SMALL_BREAKPOINT = exports.PRODUCT_BOX_CAROUSEL_SKELETON = exports.PRODUCT_BOX_CAROUSEL = exports.MEDIUM_BREAKPOINT_VALUE = exports.MEDIUM_BREAKPOINT_SETTINGS = exports.MEDIUM_BREAKPOINT_PER_VIEW = exports.MEDIUM_BREAKPOINT = exports.EXTRA_SMALL_BREAKPOINT_VALUE = exports.EXTRA_SMALL_BREAKPOINT_SETTINGS = exports.EXTRA_SMALL_BREAKPOINT_PER_VIEW = exports.EXTRA_SMALL_BREAKPOINT = exports.DEFAULT_PRODUCT_BOX_SKELETON_COUNT = void 0;
const PRODUCT_BOX_CAROUSEL = exports.PRODUCT_BOX_CAROUSEL = 'ProductBoxCarousel';
const PRODUCT_BOX_CAROUSEL_SKELETON = exports.PRODUCT_BOX_CAROUSEL_SKELETON = 'ProductBoxCarouselSkeleton';
const SMALL_BREAKPOINT_VALUE = exports.SMALL_BREAKPOINT_VALUE = 500;
const SMALL_BREAKPOINT = exports.SMALL_BREAKPOINT = `(min-width: ${SMALL_BREAKPOINT_VALUE}px)`;
const SMALL_BREAKPOINT_PER_VIEW = exports.SMALL_BREAKPOINT_PER_VIEW = 3;
const MEDIUM_BREAKPOINT_VALUE = exports.MEDIUM_BREAKPOINT_VALUE = 768;
const MEDIUM_BREAKPOINT = exports.MEDIUM_BREAKPOINT = `(min-width: ${MEDIUM_BREAKPOINT_VALUE}px)`;
const MEDIUM_BREAKPOINT_PER_VIEW = exports.MEDIUM_BREAKPOINT_PER_VIEW = 4;
const SPACING = exports.SPACING = 15;
const EXTRA_SMALL_BREAKPOINT_VALUE = exports.EXTRA_SMALL_BREAKPOINT_VALUE = 499;
const EXTRA_SMALL_BREAKPOINT = exports.EXTRA_SMALL_BREAKPOINT = `(max-width: ${EXTRA_SMALL_BREAKPOINT_VALUE}px)`;
const EXTRA_SMALL_BREAKPOINT_PER_VIEW = exports.EXTRA_SMALL_BREAKPOINT_PER_VIEW = 2.5;
const DEFAULT_PRODUCT_BOX_SKELETON_COUNT = exports.DEFAULT_PRODUCT_BOX_SKELETON_COUNT = 8;
const EXTRA_SMALL_BREAKPOINT_SETTINGS = exports.EXTRA_SMALL_BREAKPOINT_SETTINGS = {
  [EXTRA_SMALL_BREAKPOINT]: {
    slides: {
      perView: EXTRA_SMALL_BREAKPOINT_PER_VIEW,
      spacing: SPACING
    }
  }
};
const SMALL_BREAKPOINT_SETTINGS = exports.SMALL_BREAKPOINT_SETTINGS = {
  [SMALL_BREAKPOINT]: {
    slides: {
      perView: SMALL_BREAKPOINT_PER_VIEW,
      spacing: SPACING
    }
  }
};
const MEDIUM_BREAKPOINT_SETTINGS = exports.MEDIUM_BREAKPOINT_SETTINGS = {
  [MEDIUM_BREAKPOINT]: {
    slides: {
      perView: MEDIUM_BREAKPOINT_PER_VIEW,
      spacing: SPACING
    }
  }
};
//# sourceMappingURL=constants.js.map